import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import ApplicationComponent from '../application_component/ApplicationComponent.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { useToast } from '@/components/Toast/useToast';
import $ from 'jquery';

export default {
  name: 'ViewPendingApplication',
      setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
  components: {
    AdminNavBar,
    ApplicationComponent
  },
  data: () => ({
    user_id: null
  }),
  methods: {
    update_application_status(action) {
      const TOKEN = localStorage.getItem('token');
      const ACTION_APPLICATION_URL = `${API_BASE_URL}/verify_api/verify_admin_api/action_application_api/${this.user_id}`;

      $.ajax({
        url: ACTION_APPLICATION_URL,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify({
          action: action
        }),
        success: (response) => {
          if (response.status === 'Success'){
            this.showSuccess(response.message);
            this.$router.push({ name: 'client_applications' });
          }else{
            this.showError(response.message);
          }
        },
        error: (response) => {
          this.showError(response.responseJSON.error || 'An error occurred while processing the application.');
        }
      });
    },
    approve_application() {{
      this.update_application_status('approve');
      }
    },
    decline_application() {{
      this.update_application_status('decline');
    }}
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    var user_id = this.user_id || this.$route.params.user_id;
    this.user_id = user_id; // Store the user_id for future use
  }
};
